<div class="images">
  <div class="image-container" *ngFor="let image of images">
    <div class="shop-image-background">
      <div class="image-spinner">
        <lh-shared-ui-spinner [visible]="true"></lh-shared-ui-spinner>
      </div>
      <img class="shop-image" [imageName]="image" imageSize="thumb" lhImage />
    </div>
    <button id="removeShopImage" class="btn btn-info" (click)="removeImage(image)">
      <div class="icon-wrapper">
        <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
          />
          <path d="M0 0h24v24H0z" fill="none" />
        </svg>
      </div>
    </button>
  </div>
</div>

<div *ngIf="uploader">
  <input
    id="file"
    name="file"
    type="file"
    class="file-input"
    [uploader]="uploader"
    [accept]="uploader.options.allowedMimeType.join(',')"
    ng2FileSelect
    multiple
  />
  <label for="file" class="btn btn-primary btn-add">{{ 'UPLOAD_SHOP_IMAGES' | translate }}</label>

  <span class="max-size">{{ 'MAX_IMAGE_SIZE' | translate }}</span>
</div>
